module.exports = __webpack_public_path__ + "img/m2.bfe3c789.png";